/**
 * Mijn Indeling Query Hook (Epic C-5 — Mijn indeling & navigatie, Story C-5.1)
 *
 * Eigen bestand, zelfde query-keys-factory-conventie als `useConflicts.ts`/
 * `usePlanningBoard.ts` (AD-9/AD-18). Consumeert `planningApi.getMyAssignments`
 * (`GET /api/v1/planning/assignments/me`) — strikt eigen-scope, geen
 * `employeeId`-parameter (de server leidt de scope af uit het JWT).
 */

import { useQuery } from '@tanstack/react-query';
import { planningApi } from '../../../lib/planningApi';

export const myPlanningKeys = {
  all: ['myAssignments'] as const,
  range: (van: string, tot: string) => [...myPlanningKeys.all, van, tot] as const,
};

export function useMyPlanning(van: string, tot: string) {
  return useQuery({
    queryKey: myPlanningKeys.range(van, tot),
    queryFn: () => planningApi.getMyAssignments(van, tot),
    enabled: !!van && !!tot,
  });
}
